// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xtEf","textarea":"styles_textarea__3Remk"};